// extracted by mini-css-extract-plugin
export default {"fwrkSignup":"NewSignup_fwrkSignup__gNjPq"};